'use client';

import { $api } from '@shared/apis';

/**
 * /api/v1/branches/{branchId}/files — 지점 소개자료 파일 목록.
 * PDF 등 다운로드 가능한 파일의 URL·이름·크기를 반환.
 */
export function useBranchFiles(branchId: number | null) {
  const enabled = branchId != null && !Number.isNaN(branchId);
  return $api.useQuery(
    'get',
    '/api/v1/branches/{branchId}/files',
    { params: { path: { branchId: branchId ?? 0 } } },
    { enabled },
  );
}
